import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function Layout({ children, hideFooter }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#FDFBF7]" data-testid="app-layout">
      <Header />
      <main className="flex-1">{children}</main>
      {!hideFooter && <Footer />}
    </div>
  );
}
